import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { TranslationMap } from '@shared/h5p-translations/walker';

/**
 * Per-language translation overlay of one module (course activity) — Multi-
 * Language Trainings. `data` is the walker's flat map
 * (`"<itemKey>:<fieldName>" -> value`), passed through verbatim by the backend
 * resource (no per-key whitelist). One row per (activity, language).
 *
 * Batch read seam:
 * `GET /course_activity_translations?filter[course_activity_id]=1,2,3&filter[language]=de`.
 */
@JsonApiModelConfig({
  type: 'course_activity_translations',
})
export class CourseActivityTranslation extends JsonApiModel {
  @Attribute()
  language!: string;

  @Attribute()
  data!: TranslationMap;

  // Plain writable FK (mirrors the backend resource attribute).
  @Attribute({ serializedName: 'course_activity_id' })
  courseActivityId!: number;

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;

  @Attribute({ serializedName: 'updated_at' })
  updatedAt!: Date;
}
